import React from 'react';
import { HandIcon, CloseIcon } from '../components/Icons.jsx';

export default function DeckOverlays({ room, showCheck, onCloseCheck }) {
  const { understand, hands } = room.pulse;
  const total = understand.ok + understand.confused;

  return (
    <>
      {/* raised hands, top-right */}
      {hands.length > 0 && (
        <div className="deck-hands">
          <span className="deck-hands-head"><HandIcon size={14} /> ยกมือ {hands.length}</span>
          <div className="deck-hands-list">
            {hands.slice(-6).map((h) => (
              <span key={h.playerId} className="deck-hand-name">{h.nickname}</span>
            ))}
          </div>
        </div>
      )}

      {/* understand meter, bottom-left */}
      {total > 0 && (
        <div className="deck-meter" title="มิเตอร์ความเข้าใจของสไลด์นี้">
          <div className="deck-meter-bar">
            <div className="deck-meter-ok" style={{ flexGrow: understand.ok || 0.001 }} />
            <div className="deck-meter-confused" style={{ flexGrow: understand.confused || 0.001 }} />
          </div>
          <span className="deck-meter-label num">
            เข้าใจ {understand.ok} · ยังงง {understand.confused}
          </span>
        </div>
      )}

      {/* floating emoji reactions */}
      <div className="deck-reactions" aria-hidden="true">
        {room.reactions.map((r) => (
          <span key={r.id} className="deck-reaction" style={{ left: `${8 + Math.random() * 84}%` }}>{r.emoji}</span>
        ))}
      </div>

      {/* fullscreen understanding check */}
      {showCheck && (
        <div className="deck-check">
          <button className="deck-check-close" onClick={onCloseCheck} aria-label="ปิด"><CloseIcon size={22} /></button>
          <h2>เช็คความเข้าใจ</h2>
          <p className="text-dim">แตะบนมือถือของคุณ — เข้าใจ หรือ ยังงง</p>
          <div className="deck-check-bars">
            <div className="deck-check-bar is-ok">
              <span className="num">{understand.ok}</span>
              <span>เข้าใจแล้ว</span>
            </div>
            <div className="deck-check-bar is-confused">
              <span className="num">{understand.confused}</span>
              <span>ยังงง</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
